export enum ProjectActions {
  SetForm = "Set order form values",
  SelectAttr = "Select attribute",
  Reset = "Reset project",
  FetchContent = "Fetch content",
  InsertContent = "Insert content",
  InsertAttributes = "Insert attributes",
  FetchAttributes = "Fetch attributes",
  CreateProject = "Create project",
  CreateOrder = "Create order",
  InsertProject = "Insert project",
  InsertCart = "Insert cart",
  InsertOrder = "Insert order",
  FetchProject = "Fetch project",
  InsertSelectedAttributes = "Insert selected attributes",
  Center = "Center",
  SetZoom = "Set zoom",
  ChangeProjectCount = "Change project count",
  UpdateHistory = "Update history",
  AddProjectToCart = "Add project to cart",
  RemoveCart = "Remove cart",
  LoadHistory = "Load history",
  DeleteCart = "Delete cart",
  LoadCart = "Load cart",
  SetLoaded = "Set loaded",
  LoadProject = "Load project",
  UpdateCart = "Update cart",
  ChangeAttrib = "Change attribute",
}
